import React, { Component } from "react";
import Container from "./resources/container/App";
import { Router } from "@datenbanker/react-devcloud-components";

class App extends Component {
  render() {
    const { pages } = this.props;
    return (
      <Router
        pages={pages}
        layouter={{
          on: {
            signOut: "SIGN_OUT"
          }
        }}
      />
    );
  }
}
export default Container(App);
